import { required } from 'vuelidate/lib/validators'

const formData = {
  sourceSystem: {
    size: 6,
    type: 'text',
    name: 'name',
    label: 'Sistema de origem',
    placeholder: 'Digite aqui o nome do sistema de origem',
    value: null
  },
  sourceSystemCnpj: {
    size: 6,
    type: 'text',
    name: 'cnpj',
    label: 'CNPJ do sistema de origem',
    mask: 'XX.XXX.XXX/XXXX-XX',
    placeholder: 'Digite aqui o CNPJ do sistema de origem',
    value: null,
    errors: {
      isValidCnpj: 'Digite um CNPJ válido'
    }
  }
}

const validations = {
  sourceSystemCnpj: {
    value: {
      isValidCnpj (cnpj) {
        if (cnpj) {
          return this.fn_VALID_CNPJ(cnpj)
        }

        return true
      }
    }
  }
}

export { formData, validations }
